export const TEST_ID = 'batteryIcon';
